import { Injectable } from '@angular/core';
import settings from '../../../../settings.json';

@Injectable({
    providedIn: 'root'
    })

export class CustomerService{

    settings: { id: string, name: string } = settings;

}